import { INSURANCE_ERROR_CODES } from '../../constants/errors';

export const makeInsuranceErrorMessage = (code, formatMessage) => {
  switch (code) {
    case INSURANCE_ERROR_CODES.COPAY_NOT_RECEIVED:
      return {
        title: formatMessage({ id: 'appointment.form.copayIsNotReceived' }),
        message: formatMessage({ id: 'appointment.form.verifyInformation' }),
      };
    case INSURANCE_ERROR_CODES.INSURANCE_REQUEST_FAILED:
      return {
        title: formatMessage({ id: 'appointments.form.noCoverage' }),
        message: formatMessage({ id: 'appointments.form.noCoverage.tryAgain' }),
      };
    default:
      return {
        title: formatMessage({ id: 'appointments.form.noCoverage' }),
        message: formatMessage({ id: 'appointment.form.verifyInformation' }),
      };
  }
};



// WEBPACK FOOTER //
// ./src/utils/appointments/makeInsuranceErrorMessage.js